import React, {useEffect, useState} from 'react';
import '../css/Navbar.css';
import {NavLink, useLocation, useNavigate} from "react-router-dom";
import {logout} from "../services/authService";
import {useAuth} from "../utils/auth.context";
import config from '../config';
import Logo from '../assets/img/logo.png';
import Logout from '../assets/img/logout.png';
import Project from '../assets/img/project.png';
import {getMyProjects} from "../services/apiService";
import {useProject} from './ProjectProvider';
import {getCurrentUser, updateUserLanguage} from "../services/authService";
import Translate from "./Translate";


const currentUser = getCurrentUser() ? getCurrentUser() : {language: 'en'};

const Navbar = () => {


    const {user, setUser, setIsAuthenticated} = useAuth();
    const {selectedProject, setSelectedProject} = useProject();

    const [projectList, setProjectList] = useState([]);
    const [projectsActive, setProjectsActive] = useState(false);
    const [language, setLanguage] = useState('en');
    const [dropdownVisible, setDropdownVisible] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();


    useEffect(() => {
        const storedProject = localStorage.getItem('selectedProject');
        if (storedProject && location.pathname !== '/profile') {
            setSelectedProject(JSON.parse(storedProject));
            setProjectsActive(true);
        }
        return () => localStorage.removeItem('selectedProject');
    }, []);

    useEffect(() => {
        getMyProjectsList();
        fetchCurrentUser();
    }, []);

    const getMyProjectsList = async () => {
        try {
            const data = await getMyProjects(user.data._username);
            setProjectList(data);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchCurrentUser = async () => {
        try {
            const currentUser = await getCurrentUser();
            setLanguage(currentUser.language || 'en');
        } catch (error) {
            console.error(error);
        }
    };

    const handleSelectProject = (project) => {
        setSelectedProject(project);
        localStorage.setItem('selectedProject', JSON.stringify(project));
        navigate("/my-projects");
        setProjectsActive(true);
    };

    const handleLogout = () => {
        logout();
        setUser(null);
        setIsAuthenticated(false);
    };

    const handleChangeLanguage = async (newLanguage) => {
        setLanguage(newLanguage);
        setDropdownVisible(false);
        try {
            await updateUserLanguage(newLanguage);
            window.location.reload();
        } catch (error) {
            console.error('Failed to update language:', error);
        }
    };

    const toggleDropdown = () => {
        setDropdownVisible(!dropdownVisible);
    };


    return (
        <nav className="navbar">
            <div className="navbar-header">
                <h2 className="navbar-title">
                    <img className={'rp-logo'} width={30} height={30} src={Logo} alt="Logo"/>
                    <span className={'rp-title'}>Resource Provider</span>
                </h2>
            </div>
            <div className="navbar-container">
                {user?.data?.role === config.roles.admin && (
                    <>
                        <NavLink
                            to="/profile"
                            className={({isActive}) => isActive ? 'navbar-link active' : 'navbar-link'}
                        >
                            <Translate language={currentUser.language} text={'profile'}/>
                        </NavLink>
                        <NavLink
                            to="/users"
                            className={({isActive}) => isActive ? 'navbar-link active' : 'navbar-link'}
                        >
                            <Translate language={currentUser.language} text={'users'}/>
                        </NavLink>
                        <NavLink
                            to="/projects"
                            className={({isActive}) => isActive ? 'navbar-link active' : 'navbar-link'}
                        >
                            <Translate language={currentUser.language} text={'projects'}/>
                        </NavLink>
                    </>
                )}
                {(user?.data?.role === config.roles.manager || user?.data?.role === config.roles.editor) && (
                    <>
                        <NavLink
                            onClick={() => {
                                setProjectsActive(false);
                                setSelectedProject(null);
                            }}
                            to="/profile"
                            className={({isActive}) => isActive ? 'navbar-link active' : 'navbar-link'}
                        >
                            <Translate language={currentUser.language} text={'profile'}/>
                        </NavLink>
                        <div
                            className={projectsActive ? 'navbar-link navbar-link2 dropdown active' : 'navbar-link navbar-link2 dropdown'}>
                            <span>
                                <Translate language={currentUser.language} text={'myProjects'}/>
                            </span>
                            <div className="dropdown-menu">
                                {projectList.map(project => (
                                    <div
                                        key={project.id}
                                        className={`dropdown-item ${selectedProject?.id === project.id ? 'selected' : ''}`}
                                        onClick={() => handleSelectProject(project)}
                                        title={project.name}
                                    >
                                        <img className="dropdown-item-icon" width={20} height={20} src={Project}
                                             alt="Project"/>
                                        <span className="dropdown-item-name">{project.name}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </>
                )}
            </div>
            <div className="custom-language-selector">
                <div className="language-toggle" onClick={toggleDropdown}>
                    <span>{currentUser.language === 'en' ? 'English' : currentUser.language === 'ru' ? 'Russian' : 'Armenian'}</span>
                    <i className={`arrow ${dropdownVisible ? 'up' : 'down'}`}/>
                </div>
                {dropdownVisible && (
                    <div className="custom-dropdown">
                        <div className="dropdown-option" onClick={() => handleChangeLanguage('en')}>English</div>
                        <div className="dropdown-option" onClick={() => handleChangeLanguage('ru')}>Russian</div>
                        <div className="dropdown-option" onClick={() => handleChangeLanguage('hy')}>Armenian</div>
                    </div>
                )}
            </div>

            <div className="logout-btn" onClick={handleLogout}>
                <img width={30} height={30} src={Logout} alt="Logout"/>
            </div>
        </nav>
    );
};

export default Navbar;
